import React, { useEffect, useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

declare global {
  interface Window {
    grecaptchaOnload?: () => void;
    grecaptchaReady?: boolean;
  }
}

const RecaptchaV2Net = React.forwardRef<typeof ReCAPTCHA, React.ComponentProps<typeof ReCAPTCHA>>((props, ref) => {
  const [ready, setReady] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const nonce = 'ils+vsV+OAN1z2QUGBzoyQ==';

  useEffect(() => {
    if (document.querySelector('script[src*="recaptcha.net"]')) {
      setReady(true);
      return () => {};
    }

    const script = document.createElement('script');
    script.src = 'https://www.recaptcha.net/recaptcha/api.js?onload=grecaptchaOnload&render=explicit';
    script.nonce = nonce;
    script.async = true;
    script.defer = true;

    window.grecaptchaOnload = () => {
      window.grecaptchaReady = true;
      setReady(true);
    };

    document.head.appendChild(script);

    return () => {
      delete window.grecaptchaOnload;
    };
  }, []);

  if (!ready) {
    return null;
  }

  return (
    <div ref={containerRef}>
      <ReCAPTCHA {...props} ref={ref} />
    </div>
  );
});

export default RecaptchaV2Net;
